export default __webpack_public_path__ + "static/media/taco.0927c749.svg";